"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SafeAreaView_native_exports = {};
__export(SafeAreaView_native_exports, {
  SafeAreaView: () => SafeAreaView
});
module.exports = __toCommonJS(SafeAreaView_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var React = __toESM(require("react"), 1);
var import_react_native = require("react-native");
var import_safe_area = require("../platform/safe-area");
var import_InitialWindow = require("./InitialWindow");
var import_SafeAreaContext = require("./SafeAreaContext");
var ZERO_INSETS = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var SafeAreaView = /* @__PURE__ */ React.forwardRef(function(param, ref) {
  var { style, mode, edges, ...rest } = param;
  var _ref;
  var contextInsets = React.useContext(import_SafeAreaContext.SafeAreaInsetsContext);
  var insets = (_ref = contextInsets !== null && contextInsets !== void 0 ? contextInsets : import_InitialWindow.initialWindowMetrics === null || import_InitialWindow.initialWindowMetrics === void 0 ? void 0 : import_InitialWindow.initialWindowMetrics.insets) !== null && _ref !== void 0 ? _ref : ZERO_INSETS;
  var appliedStyle = React.useMemo(function() {
    return {
      ...import_react_native.StyleSheet.flatten(style),
      ...(0, import_safe_area.buildSafeAreaInsetStyle)({
        insets,
        edges,
        mode,
        style,
        resolveStyle: import_react_native.StyleSheet.flatten
      })
    };
  }, [
    style,
    insets,
    edges,
    mode
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.View, {
    ...rest,
    style: appliedStyle,
    ref
  });
});
//# sourceMappingURL=SafeAreaView.native.js.map
